import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import { Box, Form, FormField, Button, ResponsiveContext } from 'grommet';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export var NewContact = function NewContact(props) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      isLoading = _React$useState2[1];

  var responsiveContext = React.useContext(ResponsiveContext);

  var cancel = function cancel() {
    props.cancel();
  };

  var create =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(event) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isLoading(true);
              _context.next = 3;
              return props.create(event);

            case 3:
              props.cancel();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function create(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var createButton = function createButton() {
    if (loading) {
      return React.createElement(Button, {
        primary: true,
        icon: React.createElement(FontAwesomeIcon, {
          icon: ['fas', 'circle-notch'],
          spin: true,
          size: '1x'
        }),
        label: 'Creating'
      });
    } else {
      return React.createElement(Button, {
        primary: true,
        icon: React.createElement(FontAwesomeIcon, {
          icon: ['fas', 'save'],
          size: '1x'
        }),
        label: 'Create',
        type: 'submit'
      });
    }
  };

  return React.createElement(Box, {
    fill: true
  }, responsiveContext === 'small' ? React.createElement(Box, {
    background: 'statusWarning',
    height: '56px',
    justify: 'center',
    pad: 'medium',
    align: 'start'
  }, React.createElement(Button, {
    onClick: cancel
  }, React.createElement(FontAwesomeIcon, {
    icon: ['fas', 'times'],
    size: '2x'
  }))) : React.createElement(Box, {
    pad: 'medium',
    align: 'end',
    justify: 'center'
  }, React.createElement(Button, {
    onClick: cancel
  }, React.createElement(FontAwesomeIcon, {
    icon: ['fas', 'times'],
    size: '2x'
  }))), React.createElement(Box, {
    pad: 'medium'
  }, React.createElement(Form, {
    onSubmit: create
  }, React.createElement(Grid, {
    container: true,
    spacing: 24
  }, React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 4
  }, React.createElement(FormField, {
    name: 'first_name',
    label: 'First Name',
    disabled: loading
  })), React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 4
  }, React.createElement(FormField, {
    name: 'last_name',
    label: 'Last Name',
    disabled: loading
  })), React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 4
  }, React.createElement(FormField, {
    name: 'email',
    label: 'eMail Address',
    disabled: loading
  })), React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 4
  }, React.createElement(FormField, {
    name: 'primary_phone',
    label: 'Primary Phone',
    type: 'tel',
    placeholder: '###-###-####',
    disabled: loading
  })), React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 4
  }, React.createElement(FormField, {
    name: 'preferred_name',
    label: 'Preferred Name',
    disabled: loading
  })), React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 4
  }, React.createElement(FormField, {
    name: 'pronoun',
    label: 'Pronoun',
    disabled: loading
  })), React.createElement(Grid, {
    item: true,
    xs: 2,
    md: 3
  }), React.createElement(Grid, {
    item: true,
    xs: 8,
    md: 6
  }, React.createElement(Box, null, createButton()))))));
};